import { minBreakpoints } from '@noths/polaris-client-ribbons-base';
import { mediaQuery } from '@noths/polaris-client-styles';
import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { colors, spacing, typography } = themeVariables;

export const header = css`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: var(${spacing.xl}) 0;
`;

export const closeButton = css`
  display: flex;
  align-items: center;
  gap: var(${spacing.xs});
  padding: 0;
  border: none;
  background: transparent;
  color: var(${colors.content.interactive});
  cursor: pointer;
  /* Buttons don't inherit the document font, so the body family, weight and letter-spacing
     that the theme's GlobalStyles sets on <body> have to be restated here. */
  font-family: var(${typography.body.fontFamily});
  font-weight: var(${typography.body.fontWeight});
  font-size: var(${typography.body.sizes.md.fontSize});
  line-height: var(${typography.body.sizes.md.lineHeight});
  letter-spacing: var(${typography.body.letterSpacing});
`;

export const section = css`
  box-shadow: -4px 0 8px 0 rgba(0, 0, 0, 0.2);
  padding: 0 var(${spacing.md});
  position: fixed;
  background: var(${colors.surface.default});
  top: 0;
  right: 0;
  height: 100%;
  min-width: 100%;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      min-width: 0;
      padding: 0 var(${spacing.xl});
    `,
  )};
`;

export const content = css`
  padding: 0;
  overflow-y: auto;
  max-height: calc(100% - 76px); // 76px is the height of the header
  display: flex;
  gap: var(${spacing.xxl});
  flex-direction: column;
`;

/* The delivery options and their trailing caption form one group in the design, spaced more
   tightly than the gap separating that group from the FAQs section below it. */
export const datesSection = css`
  display: flex;
  flex-direction: column;
  gap: var(${spacing.xl});
`;

export const message = css`
  font-size: var(${typography.body.sizes.sm.fontSize});
  line-height: var(${typography.body.sizes.sm.lineHeight});
  color: var(${colors.content.secondary});
  text-align: center;
`;
